import DisplayTrackMP from "./DisplayTrackMP"
import DisplayTrackNW from "./DisplayTrackNW"
import DisplayTrackLS from "./DisplayTrackLS"
import { useEffect } from "react"
import useAuth from "../../../hooks/useAuth";
import Button from "../../../components/Button";
const Summary= ({ sum, backToExercises, info, parts }) => {
    console.log('JOY: summary, exercise, level 2')
    const {auth} = useAuth();
    useEffect( 
        () =>{
                const onLastHit = async (data) => {
                        
                    
                            data["id"] = info.id
                        
                            data['parts'] = parts
                            console.log(data, "data")
                            let outdata = {"activity" : {[info.name]:data}}
                            if (auth) {outdata["user_id"] = auth.id}
                            const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/stats/${info.l2}/send`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(outdata),
                            });
                            
                            // if the login is successful - get the token and then get the remaining data from the /me route
                            if (response.ok) {
                                console.log("sent data")
                            
                                };
                        }
                        if (Object.keys(sum).length >0){
                            onLastHit(sum)}
                },[sum]
            )


return (
<div className="exercise-stage !items-stretch !justify-start">
    <div className="mb-6 text-center">
        <p className="panel-heading">Session complete</p>
        <h1 className="page-heading !text-4xl">Your results</h1>
    </div>

{(Object.keys(sum).length ===0)&&<div className="empty-state">No exercises completed.</div>}
{(Object.keys(sum).length >0)&&Object.keys(sum).map(k => {
    return (
    <section className="mb-6" key={k}>
    <h2 className="mb-3 text-lg font-bold text-cyan-950">{k}</h2>

    {Object.keys(sum[k].results).map(el => {
        return(
            <div
                key={el}
                className={`exercise-result-card ${(sum[k].results[el].eval === true || sum[k].results[el].eval === 'Good' ) ? "exercise-result-correct" : "exercise-result-wrong"}`}
            >
                
                {(k === "ListenAndClick")&&<DisplayTrackMP currentTrack={sum[k].results[el].choice} />}
                {(k === "ListenAndClickII")&&<DisplayTrackNW currentTrack={sum[k].results[el].target} />}
                {(k === "ListenAndSpeak")&&<DisplayTrackLS currentTrack={sum[k].results[el].choice} />}
                {(k === "ListenAndWrite")&&<div className="flex flex-col m-auto">
                        <div className="flex">
                             <p className="text-md">You typed: {sum[k].results[el].typed}</p>
                        </div>
                        <DisplayTrackLS currentTrack={sum[k].results[el].choice} />
                        </div>}
                
            </div>
        )
    }
    )
    }
    </section>
    )
    }
    

    )

}


<div className="flex justify-center py-2">
<Button text="Back to exercises" func={() => {backToExercises(false);}} variant="secondary" />
</div>
</div>
)
}


export default Summary;
